import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@plan/env/environment';
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { SENTRY_IGNORE_ERRORS, sentryBeforeSend } from '@agilox/sentry';

if (environment.production) {
	enableProdMode();

	Sentry.init({
		dsn: 'https://935444f9880a7cf5a86997241096a492@o919676.ingest.us.sentry.io/4508714407428096',
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
		tracePropagationTargets: ['https://plan.agilox.net'],
		ignoreErrors: SENTRY_IGNORE_ERRORS,
		beforeSend: sentryBeforeSend,
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		tracesSampleRate: 0.5,
	});
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
